import React from "react";
import Icon from "@ant-design/icons";


const StaffInProcessSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M45,13.8c-.6-.3-1.4-.1-1.7.5l-5.2,9.3c-.4-9.2-7.9-16.6-17.2-16.6S3.6,14.7,3.6,24.3s7.7,17.3,17.3,17.3,1.2-.6,1.2-1.2-.6-1.2-1.2-1.2c-8.1,0-14.8-6.6-14.8-14.8s6.6-14.8,14.8-14.8,14.5,6.4,14.7,14.4l-8.7-5.3c-.6-.4-1.4-.2-1.7.4-.4.6-.2,1.4.4,1.7l11.5,7c.2.1.4.2.7.2s.2,0,.3,0c.3,0,.6-.3.8-.6l6.6-11.8c.3-.6.1-1.4-.5-1.7Z" />
    </svg>
);

const StaffInProcessIcon = (props) => <Icon { ...props } component={ StaffInProcessSvg } />;

export default StaffInProcessIcon;
